module.exports = "./img/desktop_logo.d18da9d.png";